import React from 'react';

//types
import { IIconProps } from 'assets/icons/IconProps';

export const RotateIcon = ({
  width = 24,
  height = 24,
  stroke = '#E8E8E8',
  strokeWidth = 2,
}: IIconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    fill="none"
    viewBox="0 0 24 24"
  >
    <path
      stroke={stroke}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M23 4v6h-6"
    />
    <path
      stroke={stroke}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M20.49 15c-.65 1.84-1.88 3.419-3.506 4.498-1.625 1.08-3.558 1.603-5.506 1.489-1.948-.114-3.806-.858-5.294-2.12-1.489-1.262-2.527-2.974-2.958-4.877-.43-1.903-.232-3.895.568-5.675.8-1.78 2.155-3.252 3.864-4.194 1.71-.943 3.678-1.304 5.61-1.03C15.2 3.365 16.99 4.26 18.37 5.64L23 10"
    />
  </svg>
);
